import $dayjs from '@/services/date'
import Environment from '@/shared/constants/core/Environment'

const development = () =>
  fetch(
    `${process.env.BASE_URL}config.dev.json?t=${$dayjs().valueOf()}`
  ).then((response) => response.json())

const production = () =>
  fetch(
    `${process.env.BASE_URL}config.runtime.json?t=${$dayjs().valueOf()}`
  ).then((response) => response.json())

const loadConfig = (environment) => {
  switch (environment) {
    case Environment.production:
      return production()
    case Environment.development:
    default:
      return development()
  }
}

export default async () => await loadConfig(process.env.NODE_ENV)
